import React, { useEffect } from "react";
import { HashRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Application from "./application/Application";
import Panel from "./panel/Panel";
import Tos from "./footer/Tos";
import Policy from "./footer/Policy";
// import reportWebVitals from "./reportWebVitals";
import Roleplay from "./rules/Roleplay";
import Rules from "./rules/Rules";
import MedRP from "./rules/MedRP";
import Faq from "./rules/Faq";

import View from "./panel/View";

import Cookies from "./cookies/cookies";
import { HelmetProvider } from "react-helmet-async";
function PrivateRoute({ children, admin, login }) {
  let auth = false;
  const isLogged = localStorage.getItem("isLogged");
  const isAdmin = localStorage.getItem("isAdmin");

  if (isLogged == "true" && login && !admin) {
    auth = true;
  } else if (isAdmin == "true" && admin && isLogged == "true" && login) {
    auth = true;
  } else {
    window.alert("Musisz być zalogowany, aby zobaczyć tę stronę.");
    auth = false;
  }
  console.log(auth, "auth", typeof isAdmin);
  return auth ? <>{children}</> : <Navigate to="/" />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
  <React.StrictMode>
    <HashRouter>
      <Routes>
          <Route path="/" element={<App />} /> 
        <Route
          path="/application"
          element={
            <PrivateRoute admin={false} login={true}>
              <Application />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/panel"
          element={
            <PrivateRoute admin={true} login={true}>
              <Panel />
            </PrivateRoute>
          }
        ></Route>
        <Route path="/policy" element={<Policy />} />
        <Route path="/roleplay" element={<Roleplay />} />
        <Route path="/tos" element={<Tos />} />
        <Route path="/view" element={<View />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="/medrp" element={<MedRP />} />
        <Route path="/faq" element={<Faq />} />
      </Routes>
    </HashRouter>
    <Cookies />
  </React.StrictMode>
  </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
